// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__1QPtI","select":"Header_select__3WWrm","clinic":"Header_clinic__3b5Fr"};